import { render, staticRenderFns } from "./DataPropertyProfileList.vue?vue&type=template&id=78e275a5&scoped=true&"
import script from "./DataPropertyProfileList.vue?vue&type=script&lang=js&"
export * from "./DataPropertyProfileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e275a5",
  null
  
)

export default component.exports